import { createFileRoute } from "@tanstack/react-router";
import { LiveAdminPage } from "@/components/shared/LiveAdminPage";
export const Route = createFileRoute("/admin.analytics")({ component: Page });
function Page() {
  return (
    <LiveAdminPage
      title="Analytics"
      description="Live operational data."
      table="orders"
      columns={[
        { key: "order_number", label: "Order" },
        { key: "total", label: "Total" },
        { key: "payment_status", label: "Payment" },
        { key: "created_at", label: "Created" },
      ]}
    />
  );
}